<template>
	<v-list-tile v-bind:key="event.uuid" @click.stop="open">
		<v-list-tile-content style="min-width: 60px; max-width: 60px !important;">
    	<v-list-tile-title :class="$dark() ? 'white--text' : 'black--text'">{{event.cached_start_time | format_time}}</v-list-tile-title>
      <v-list-tile-sub-title class="grey--text" style="font-size: 11px;">{{event.cached_end_time | format_time}}</v-list-tile-sub-title>
		</v-list-tile-content>

   	<v-list-tile-content style="width: 30%;">
     	<v-list-tile-title>{{ title }}</v-list-tile-title>
     	<v-list-tile-sub-title class="grey--text text--lighten-1">
				{{subtitle}}&nbsp;
			</v-list-tile-sub-title>
		</v-list-tile-content>

	</v-list-tile>
</template>

<script>
import datelib from '@/lib/date.js';
import EventModel from '@/models/event.js'

export default {
	props: ["event", "start", "end"],
 	filters: {
  	...datelib
  },
  data () {
    return {
      subtitle: ""
    }
  },
  created () {
    var self = this;
    EventModel.subtitle_cb(this.event, "", function(val) {
      self.subtitle = val;
    })
  },
  methods: {
  	open() {
      this.$router.push("/cloudrec/event/"+this.event.uuid+"?start="+this.start+"&end="+this.end);
  	}
  },
  computed: {
  	title () {
      return EventModel.title(this.event);
		}
	}
}
</script>